export function floatingUpButton() {
	const div = document.createElement("div");
	div.classList.add("float-btn-container");

	const button = document.createElement("button");
	button.classList.add("float-btn");
	const icon = document.createElement("span");
	icon.classList.add("icon");

	button.addEventListener("click", () => {
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	});

	div.append(button);
	div.append(icon);
	document.body.append(div);

	let hideTimeout: number | undefined;

	const isVisible = () => div.classList.contains("show");

	const isMenuPopupOpen = () =>
		document.body.classList.contains("hallv-menu-popup-open");

	const isClickInsideFloatingUi = (target: EventTarget | null): boolean => {
		const node = target as Node | null;
		if (!node) return false;

		// Float "scroll to top" button UI
		if (div.contains(node)) return true;

		// Menu popup
		const popup = document.getElementById("hallv-menu-popup");
		if (popup && popup.contains(node)) return true;

		// Menu button (lives in `.theme-toggle` container, but we no longer manage that container here)
		const menuBtn = document.querySelector(
			'.theme-toggle button[data-role="menu"]',
		);
		if (menuBtn instanceof HTMLElement && menuBtn.contains(node)) return true;

		return false;
	};

	const hideControls = () => {
		// Keep controls visible while the menu popup is open (prevents UX traps).
		if (isMenuPopupOpen()) return;

		div.classList.remove("show");
		if (hideTimeout) {
			window.clearTimeout(hideTimeout);
			hideTimeout = undefined;
		}
	};

	const showControls = () => {
		div.classList.add("show");

		// If the menu popup is open, don't auto-hide the controls.
		if (isMenuPopupOpen()) {
			if (hideTimeout) {
				window.clearTimeout(hideTimeout);
				hideTimeout = undefined;
			}
			return;
		}

		if (hideTimeout) {
			window.clearTimeout(hideTimeout);
		}
		hideTimeout = window.setTimeout(hideControls, 3000);
	};

	const toggleControls = () => {
		if (isVisible()) {
			hideControls();
		} else {
			showControls();
		}
	};

	console.log("[floating_button] init");

	window.addEventListener("scroll", showControls, { passive: true });
	window.addEventListener(
		"click",
		(e) => {
			// Don't toggle visibility when interacting with the floating UI/popup.
			if (isClickInsideFloatingUi(e.target)) return;

			// If popup is open, keep controls visible (click-away behavior is handled by my_main.ts).
			if (isMenuPopupOpen()) {
				showControls();
				return;
			}

			toggleControls();
		},
		{ passive: true },
	);
}
